import { HTMLInputTypeAttribute } from 'react'
import { INPUT_CLASS, LABEL_CLASS } from '../../_ui/forms/styles'

type PropTypes = {
  id: string
  label: string
  type?: HTMLInputTypeAttribute
  autoComplete?: string
  value: string
  onChange: (value: string) => void
}

export const FormField = ({ id, label, type = 'text', autoComplete, value, onChange }: PropTypes) => {
  return (
    <div>
      <label
        htmlFor={id}
        className={`${LABEL_CLASS} mb-1.5 text-sm`}
      >
        {label}
      </label>
      <input
        id={id}
        name={id}
        type={type}
        autoComplete={autoComplete}
        required
        value={value}
        onChange={event => onChange(event.target.value)}
        className={`${INPUT_CLASS} text-sm`}
      />
    </div>
  )
}
